import WRAP from "WRAP-JS";

/* eslint-disable */
// 元のコンストラクタを保持
const OriginalConstructor = WRAP.Geo.WebGLContext;
// 新しいコンストラクタで置き換え
WRAP.Geo.WebGLContext = function(view) {
  // 元のコンストラクタを呼ぶ
  OriginalConstructor.call(this, view);

  // テッセレートの上限拡張
  this.max_tessellate_vertices = 50000; // 20000 → 50000
  this.max_tessellate_triangles = 50000; // 10000 → 50000
  this.tessellate_vertices = new Float64Array(this.max_tessellate_vertices * 2);
  this.tessellate_triangles = new Int32Array(this.max_tessellate_triangles * 3);
}
// prototype を引き継ぐ
WRAP.Geo.WebGLContext.prototype = OriginalConstructor.prototype;
WRAP.Geo.WebGLContext.prototype.constructor = WRAP.Geo.WebGLContext;

// Shader.Gradient を追加
WRAP.Geo.WebGLContext.prototype.Shader.Gradient = function(context, gl) {
    WRAP.Geo.WebGLContext.prototype.Shader.Base.call(this, context, gl);

    this.setup(
      // 頂点シェーダー（変更なし）
      "attribute vec2 offset;" +
      "attribute float progress;" +
      "attribute float alpha;" +
      "varying float v_progress;" +
      "varying float v_alpha;" +
      "void main()" +
      "{" +
      "    vec4 s = proj();" +
      "    float a = s.a;" +
      "    if ( a <= 0.2 ) {" +
      "       a = 0.0;" +
      "    }" +
      "    else {" +
      "       a = 1.0-((a-0.2)/0.8);" +
      "       a = 1.0-a*a;" +
      "    }" +
      "    vec4 p = vec4(s.x+offset.x, s.y+offset.y, s.z, 1.0);" +
      "    if ( z_scale > 0.0 ) {" +
      "        gl_Position = projection * p;" +
      "    }" +
      "    else {" +
      "        gl_Position = p * projection;" +
      "    }" +
      "    v_progress = progress;" +
      "    v_alpha = a * alpha;" +
      "}",

      // フラグメントシェーダー（複数色対応）
      "precision mediump float;\n" +
      "uniform vec4 colors[10];" +      // 最大10色
      "uniform float stops[10];" +      // 各色の位置 (0.0〜1.0)
      "uniform int colorCount;" +       // 実際の色数
      "varying float v_progress;" +
      "varying float v_alpha;" +
      "void main()" +
      "{" +
      "    vec4 color = colors[0];" +
      "    for (int i = 0; i < 9; i++) {" +  // colorCount-1 まで
      "        if (i >= colorCount - 1) break;" +
      "        if (v_progress >= stops[i] && v_progress <= stops[i+1]) {" +
      "            float t = (v_progress - stops[i]) / (stops[i+1] - stops[i]);" +
      "            color = mix(colors[i], colors[i+1], t);" +
      "            break;" +
      "        }" +
      "    }" +
      "    gl_FragColor = vec4(color.rgb, color.a * v_alpha);" +
      "}"
    );

    // attribute/uniformの取得
    this.position = gl.getAttribLocation(this.pg, "position");
    this.offset = gl.getAttribLocation(this.pg, "offset");
    this.progress = gl.getAttribLocation(this.pg, "progress");
    this.alpha = gl.getAttribLocation(this.pg, "alpha");
    this.colors = gl.getUniformLocation(this.pg, "colors");
    this.stops = gl.getUniformLocation(this.pg, "stops");
    this.colorCount = gl.getUniformLocation(this.pg, "colorCount");

    this.draw = function(type, proj, vbo, elements) {
      gl.useProgram(this.pg);

      this.proj.draw(gl, this, proj);

      var floatsize = 4;
      var stride = 7 * floatsize;
      gl.bindBuffer(gl.ARRAY_BUFFER, vbo);

      gl.vertexAttribPointer(this.position, 3, gl.FLOAT, false, stride, 0);
      gl.enableVertexAttribArray(this.position);

      gl.vertexAttribPointer(this.progress, 1, gl.FLOAT, false, stride, 3*floatsize);
      gl.enableVertexAttribArray(this.progress);

      gl.vertexAttribPointer(this.offset, 2, gl.FLOAT, false, stride, 4*floatsize);
      gl.enableVertexAttribArray(this.offset);

      gl.vertexAttribPointer(this.alpha, 1, gl.FLOAT, false, stride, 6*floatsize);
      gl.enableVertexAttribArray(this.alpha);

      for ( var i = 0 ; i < elements.length ; i++ ) {
        var e = elements[i];
        if ( e.gradientColors && e.gradientStops ) {
          // 色配列を平坦化 [[r,g,b,a], [r,g,b,a], ...] -> [r,g,b,a,r,g,b,a,...]
          var flatColors = [];
          for (var j = 0; j < e.gradientColors.length && j < 10; j++) {
            flatColors.push(e.gradientColors[j][0]);
            flatColors.push(e.gradientColors[j][1]);
            flatColors.push(e.gradientColors[j][2]);
            flatColors.push(e.gradientColors[j][3]);
          }

          gl.uniform4fv(this.colors, flatColors);
          gl.uniform1fv(this.stops, e.gradientStops);
          gl.uniform1i(this.colorCount, e.gradientColors.length);

          if ( e.num )
            gl.drawArrays(type, e.index, e.num);
        }
      }

      gl.disableVertexAttribArray(this.position);
      gl.disableVertexAttribArray(this.offset);
      gl.disableVertexAttribArray(this.progress);
      gl.disableVertexAttribArray(this.alpha);
    }

};

// Shader.Pointのアンチエイリアスが汚いので上書き
WRAP.Geo.WebGLContext.prototype.Shader.Point = function(context, gl) {
  WRAP.Geo.WebGLContext.prototype.Shader.Base.call(this, context, gl);

  const vertexShader = `
        attribute vec4 color;
        attribute float value;
        attribute float hole;
        attribute float blink;
        uniform float alpha;
        varying float v_fill;
        varying vec4 v_color;
        varying float v_size;
        
        void main() {
            vec4 s = proj();
            float a = 1.0;
            if (s.a <= 0.0) {
                a = 0.0;
            }
            s.w = 1.0;
            if (z_scale > 0.0) {
                gl_Position = projection * s;
            } else {
                gl_Position = s * projection;
            }
            gl_PointSize = value;
            if (blink == 0.0) {
                v_color = vec4(color.r, color.g, color.b, color.a * a);
            } else {
                v_color = vec4(color.r, color.g, color.b, color.a * alpha * a);
            }
            v_fill = hole / value;
            v_size = value;
        }
    `;

  const fragmentShader = context.gl_exntention_standard_derivatives ? `
        #extension GL_OES_standard_derivatives : enable
        precision mediump float;
        varying float v_fill;
        varying vec4 v_color;
        varying float v_size;
        
        void main() {
            vec2 cxy = 2.0 * gl_PointCoord - 1.0;
            float r = length(cxy);
            float delta = fwidth(r);
            
            float alpha = 0.0;
            if (v_fill > 0.0) {
                // 枠線: 外側と内側でアンチエイリアス
                float outer = 1.0 - smoothstep(1.0 - delta, 1.0 + delta, r);
                float inner = smoothstep(v_fill - delta, v_fill + delta, r);
                alpha = outer * inner;
            } else {
                // 塗りつぶし: 外側のみアンチエイリアス
                alpha = 1.0 - smoothstep(1.0 - delta, 1.0 + delta, r);
            }
            
            gl_FragColor = vec4(v_color.rgb, v_color.a * alpha);
        }
    ` : `
        precision mediump float;
        varying float v_fill;
        varying vec4 v_color;
        varying float v_size;
        
        void main() {
            vec2 cxy = 2.0 * gl_PointCoord - 1.0;
            float r = length(cxy);
            
            // ポイントサイズに応じた動的なdelta
            float pixelSize = 2.0 / v_size;
            
            float alpha = 0.0;
            if (v_fill > 0.0) {
                // 枠線
                float outer = 1.0 - smoothstep(1.0 - pixelSize, 1.0, r);
                float inner = smoothstep(v_fill - pixelSize, v_fill, r);
                alpha = outer * inner;
            } else {
                // 塗りつぶし
                alpha = 1.0 - smoothstep(1.0 - pixelSize, 1.0, r);
            }
            
            gl_FragColor = vec4(v_color.rgb, v_color.a * alpha);
        }
    `;

  this.setup(vertexShader, fragmentShader);

  // accessor
  this.position = gl.getAttribLocation(this.pg, "position");
  this.color = gl.getAttribLocation(this.pg, "color");
  this.value = gl.getAttribLocation(this.pg, "value");
  this.hole = gl.getAttribLocation(this.pg, "hole");
  this.blink = gl.getAttribLocation(this.pg, "blink");
  this.alpha = gl.getUniformLocation(this.pg, "alpha");

  this.draw = function(type, proj, vbo, elements) {
    gl.useProgram(this.pg);

    this.proj.draw(gl, this, proj);

    gl.uniform1f(this.alpha, context.blink_rate);

    var floatsize = 4;
    var stride = 10*floatsize;
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
    gl.vertexAttribPointer(this.position, 3, gl.FLOAT, false, stride, 0);
    gl.enableVertexAttribArray(this.position);
    gl.vertexAttribPointer(this.color, 4, gl.FLOAT, false, stride, 3*floatsize);
    gl.enableVertexAttribArray(this.color);
    gl.vertexAttribPointer(this.value, 1, gl.FLOAT, false, stride, 7*floatsize);
    gl.enableVertexAttribArray(this.value);
    gl.vertexAttribPointer(this.hole, 1, gl.FLOAT, false, stride, 8*floatsize);
    gl.enableVertexAttribArray(this.hole);
    gl.vertexAttribPointer(this.blink, 1, gl.FLOAT, false, stride, 9*floatsize);
    gl.enableVertexAttribArray(this.blink);

    for ( var i = 0 ; i < elements.length ; i++ ) {
      var e = elements[i];
      if ( e.num )
        gl.drawArrays(type, e.index, e.num);
    }

    gl.disableVertexAttribArray(this.position);
    gl.disableVertexAttribArray(this.color);
    gl.disableVertexAttribArray(this.hole);
    gl.disableVertexAttribArray(this.value);
    gl.disableVertexAttribArray(this.blink);
  }
};

// Texture用の共有canvas
var _textureCanvas = null;
var _textureContext = null;
var _textureCanvasFrequent = null;
var _textureContextFrequent = null;

function getTextureCanvas(needsFrequentRead) {
  if (needsFrequentRead) {
    if (!_textureCanvasFrequent) {
      _textureCanvasFrequent = document.createElement('canvas');
      _textureContextFrequent = _textureCanvasFrequent.getContext('2d', { willReadFrequently: true });
    }
    return { canvas: _textureCanvasFrequent, ctx: _textureContextFrequent };
  } else {
    if (!_textureCanvas) {
      _textureCanvas = document.createElement('canvas');
      _textureContext = _textureCanvas.getContext('2d');
    }
    return { canvas: _textureCanvas, ctx: _textureContext };
  }
}

Object.assign(WRAP.Geo.WebGLContext.prototype, {
  // Shader.Gradientを追加するためオーバーライド
  setProjection: function(name, projection) {
    this.revision++;
    if ( this.projection_type != name ) {
      this.projection_type = name;
      if ( this.shader ) {
        this.shader.color.delete();
        this.shader.point.delete();
        this.shader.texture.delete();
        this.shader.tile.delete();
        this.shader.flow.delete();
        this.shader.move.delete();
        this.shader.model.delete();
        this.shader.gradient.delete(); // Gradient追加
      }
      this.shader = {
        color: new this.Shader.Color(this, this.gl),
        point: new this.Shader.Point(this, this.gl),
        texture: new this.Shader.Texture(this, this.gl),
        tile: new this.Shader.Tile(this, this.gl),
        flow: new this.Shader.Flow(this, this.gl),
        move: new this.Shader.Move(this, this.gl),
        model: new this.Shader.Model(this, this.gl),
        gradient: new this.Shader.Gradient(this, this.gl) // Gradient追加
      }
    }
    this.projection = projection;
  },

  // Gradient用に処理を追加
  setVertex7: function(f1, f2, f3, f4, f5, f6, f7) {
    var v = this.currentElement.vertices_stack;
    WRAP.Memory.realloc(v, 7);
    v = v.block;
    v.data[v.length++] = f1;
    v.data[v.length++] = f2;
    v.data[v.length++] = f3;
    v.data[v.length++] = f4;
    v.data[v.length++] = f5;
    v.data[v.length++] = f6;
    v.data[v.length++] = f7;
    this.currentElement.num++;
    this.currentSet.num++;
  },


  // Gradient用の処理を追加するためにオーバーライド
  _drawLines: function(lines, lineWidth, lineDash, strokeStyle, fillStyle, texture, option, screen_base) {

    function mp(a, b) {
      return [(a[0]+b[0])/2, (a[1]+b[1])/2];
    }

    function bp(a, c, b) {
      var ac = mp(a, c);
      var bc = mp(b, c);
      return mp(ac, bc);
    }

    if ( fillStyle || texture ) {
      if ( texture || !this.orthogonal )
        this.setDisplayBufferState(['zoom','center']);

      for ( var i = 0 ; i < lines.length ; i++ ) {
        var line = lines[i];
        if ( line.length > 1 ) {
          var fp = line[0];
          var lp = line[line.length-1];
          if ( fp[0] != lp[0] || fp[1] != lp[1] )
            line.push(fp.slice());
        }
      }
    }

    var separated_polygon = [];
    if ( option == 'cloud' || option == 'counter_cloud') {
      this.setDisplayBufferState(['zoom','center']);
      var PI_DIV_3 = Math.PI/3;
      if ( option == 'counter_cloud' )
        PI_DIV_3 = -PI_DIV_3;
      var COS_PI_DIV_3 = Math.cos(PI_DIV_3);
      var SIN_PI_DIV_3 = Math.sin(PI_DIV_3);

      var tl = 10;
      var ol = [];
      for ( var i = 0 ; i < lines.length ; i++ ) {
        var line = lines[i];
        separated_polygon.push(line);
        var sl = [];
        this.view.projection.strict = true;
        for ( var j = 0 ; j < line.length ; j++ ) {
          var p = line[j];
          var sp = this.view.screenPoint(p);
          if ( sp[2] === undefined || sp[2] > 0 )
            sl.push(sp);
        }
        this.view.projection.strict = false;
        if ( sl.length < 2 )
          continue;

        var cl = [];
        var p = sl[0];
        var x = p[0];
        var y = p[1];
        var j = 0;
        cl.push(p);
        var lx = x;
        var ly = y;
        var rl = tl;
        var curve_start = 0;
        while ( ++j < sl.length ) {
          var a = sl[j][2];
          var ex = sl[j][0];
          var ey = sl[j][1];
          var dx = ex-x;
          var dy = ey-y;
          var el = 0;
          var ll = Math.sqrt(dx*dx+dy*dy);
          var l = ll;
          var removable = false;
          while (l >= rl) {
            el += rl;
            var r = el/ll;
            var tx = x + dx*r;
            var ty = y + dy*r;
            var curved = false;
            if ( this.visibleLine(lx,ly,tx,ty) ) {
              var mx = tx-lx;
              var my = ty-ly;
              // rotate 60 deg
              var cx = COS_PI_DIV_3 * mx - SIN_PI_DIV_3 * my + lx;
              var cy = SIN_PI_DIV_3 * mx + COS_PI_DIV_3 * my + ly;
              var cp = bp([lx,ly],[cx,cy],[tx,ty]);
              var lc = mp([lx,ly],[cx,cy]);
              var tc = mp([tx,ty],[cx,cy]);
              var cpl = bp([lx,ly],lc,cp);
              var cpt = bp([tx,ty],tc,cp);
              if ( isNaN(a) || a > 0.1 ) {    // skip orthographic edge
                cl.push(cpl);
                cl.push(cp);
                cl.push(cpt);
                curved = true;
              }
            }
            if ( removable )
              cl.pop();
            cl.push([tx,ty]);
            removable = !curved;
            if ( curved ) {
              var cloud_curve = [];
              for ( v = j ; v >= curve_start ; v-- ) {
                cloud_curve.push(sl[v]);
              }
              cloud_curve.push([lx,ly]);
              cloud_curve.push(cpl);
              cloud_curve.push(cp);
              cloud_curve.push(cpt);
              cloud_curve.push([tx,ty]);
              cloud_curve.push(cloud_curve[0]);
              var dl = [];
              for ( var w = 0 ; w < cloud_curve.length ; w++ ) {
                var p = cloud_curve[w];
                var dp = this.view.point(p);
                if ( !isNaN(dp[0]) && !isNaN(dp[1]) )
                  dl.push(dp);
              }
              if ( !this.view.band )
                dl = this.view.normalizeLine(dl);
              separated_polygon.push(dl);
              curved = false;
            }
            curve_start = j;
            lx = tx;
            ly = ty;
            l -= rl;
            rl = tl;
          }
          rl -= l;
          x = ex;
          y = ey;
        }
        cl.push(sl[sl.length-1]);

        var dl = [];
        for ( var j = 0 ; j < cl.length ; j++ ) {
          var p = cl[j];
          var dp = this.view.point(p);
          if ( !isNaN(dp[0]) && !isNaN(dp[1]) )
            dl.push(dp);
        }
        if ( !this.view.band )
          dl = this.view.normalizeLine(dl);
        ol.push(dl);
      }
      lines = ol;
    }

    var additional_lines = [];
    if ( option == 'outset' || option == 'inset' ) {
      this.setDisplayBufferState(['zoom','center']);

      var PI_DIV_3 = Math.PI/3;
      if ( option == 'inset' )
        PI_DIV_3 = -PI_DIV_3;
      var COS_PI_DIV_3 = Math.cos(PI_DIV_3);
      var SIN_PI_DIV_3 = Math.sin(PI_DIV_3);

      var tl = 10;
      var min_x = -tl;
      var max_x = this.size[0]+tl;
      var min_y = -tl;
      var max_y = this.size[1]+tl;

      for ( var i = 0 ; i < lines.length ; i++ ) {
        var line = lines[i];
        var sl = [];
        this.view.projection.strict = true;
        for ( var j = 0 ; j < line.length ; j++ ) {
          var p = line[j];
          var sp = this.view.screenPoint(p);
          sl.push(sp);
        }
        this.view.projection.strict = false;

        var rr = 0;
        var j = 0;
        while ( ++j < sl.length ) {
          var a = sl[j-1][2];
          if ( a !== undefined ) {
            if ( isNaN(a) || a < 0 )
              continue;
          }
          var lx = sl[j-1][0], ly = sl[j-1][1];
          var ex = sl[j][0], ey = sl[j][1];
          var dx = ex-lx, dy = ey-ly;
          var ll = Math.sqrt(dx*dx+dy*dy);
          if ( this.view.band || ((dx <= 0 && min_x < lx ) || (dx >= 0 && lx < max_x))
            && ((dy <= 0 && min_y < ly ) || (dy >= 0 && ly < max_y)) ) {
            var lr = ll/tl;
            var r = tl/ll;
            var tx = dx*r, ty = dy*r;
            var x = lx, y = ly;
            lr += rr;
            x -= tx*rr, y -= ty*rr;

            if ( !this.view.band ) {
              if ( tx > 0 && x < min_x ) {
                var skip = Math.floor((min_x - x)/tx);
                if ( skip > Math.floor(lr) )
                  skip = Math.floor(lr);
                lr -= skip;
                x += tx*skip, y += ty*skip;
              }
              else if ( tx < 0 && max_x < x) {
                var skip = Math.floor((x - max_x)/-tx);
                if ( skip > Math.floor(lr) )
                  skip = Math.floor(lr);
                lr -= skip;
                x += tx*skip, y += ty*skip;
              }
              if ( ty > 0 && y < min_y ) {
                var skip = Math.floor((min_y - y)/ty);
                if ( skip > Math.floor(lr) )
                  skip = Math.floor(lr);
                lr -= skip;
                x += tx*skip, y += ty*skip;
              }
              else if ( ty < 0 && max_y < y) {
                var skip = Math.floor((y - max_y)/-ty);
                if ( skip > Math.floor(lr) )
                  skip = Math.floor(lr);
                lr -= skip;
                x += tx*skip, y += ty*skip;
              }
            }

            while ( lr >= 1.0 ) {
              lx = x, ly = y;
              x += tx, y += ty;
              var hx = lx+0.5*tx, hy = ly+0.5*ty;
              // rotate 60 deg
              var cx = COS_PI_DIV_3 * tx - SIN_PI_DIV_3 * ty + hx;
              var cy = SIN_PI_DIV_3 * tx + COS_PI_DIV_3 * ty + hy;
              if ( this.visibleLine(cx,cy,x,y) ) {
                var p0 = this.view.point([cx,cy]);
                var p1 = this.view.point([x,y]);
                if ( !isNaN(p0[0]) && !isNaN(p0[1]) && !isNaN(p1[0]) && !isNaN(p0[1])) {
                  additional_lines.push(p0);
                  additional_lines.push(p1);
                }
              }
              lr -= 1.0;

              if ( !this.view.band ) {
                if ( tx > 0 && max_x <= x ) {
                  lr = lr-Math.floor(lr);
                  break;
                }
                else if ( tx < 0 && x <= min_x ) {
                  lr = lr-Math.floor(lr);
                  break;
                }
                if ( ty > 0 && max_y <= y ) {
                  lr = lr-Math.floor(lr);
                  break;
                }
                else if ( ty < 0 && y <= min_y ) {
                  lr = lr-Math.floor(lr);
                  break;
                }
              }
            }
            rr = lr;
          }
        }
      }
    }

    var stroke_lines = lines;

    if ( texture || fillStyle ) {
      if ( separated_polygon.length )
        lines = separated_polygon;
      if ( !screen_base && (!this.three_dimensional || this.zoom >= 6) ) {
        var contours = [];
        for ( var i = 0 ; i < lines.length ; i++ ) {
          var line = lines[i];
          var pa = new Float32Array(line.length*2);
          var k = 0;
          for ( var j = 0 ; j < line.length ; j++ ) {
            var x = line[j][0], y = line[j][1];
            if ( !isNaN(x) && !isNaN(y) ) {
              pa[k++] = x;
              pa[k++] = y;
            }
          }
          if ( k > 4 ) {
            if ( pa.length != k ) {
              var ta = new Float32Array(k);
              for ( var j = 0 ; j < k ; j++ )
                ta[j] = pa[j];
              pa = ta;
            }
            contours.push(pa);
          }
        }
        var vi = this.tessellate(contours);
        if ( vi && vi.count ) {
          if ( texture ) {
            this.setElement('texture', 'triangles', {texture:texture.id});
            for ( var j = 0 ; j < vi.count ; j++ ) {
              var index = vi.triangles[j]*2;
              var x = vi.vertices[index];
              var y = vi.vertices[index+1];
              var sp = this.view.screenPoint([x, y]);
              this.setVertex13(x, y, 0, 0, 0, sp[0]/texture.width, sp[1]/texture.height,
                1.0, 1.0, 1.0, 1.0, 0, this.alpha);
            }
          }
          else if ( fillStyle ) {
            var color = this.getColor(fillStyle);
            this.setElement('color', 'triangles', {});
            for ( var j = 0 ; j < vi.count ; j++ ) {
              var index = vi.triangles[j]*2;
              var x = vi.vertices[index];
              var y = vi.vertices[index+1];
              this.setVertex11(x, y, 0, color[0], color[1], color[2], color[3], 0, 0, 0, this.alpha);
            }
          }
        }
      }
      else {                     // screen base tessellation
        var contours = [];
        this.view.projection.strict = true;
        for ( var i = 0 ; i < lines.length ; i++ ) {
          var line = lines[i];
          var pa = new Float32Array(line.length*2);
          var k = 0;
          for ( var j = 0 ; j < line.length ; j++ ) {
            var x = line[j][0], y = line[j][1];
            if ( !isNaN(x) && !isNaN(y) ) {
              var c = this.view.screenPoint([x,y]);
              if ( c[2] === undefined || (!isNaN(c[2]) && c[2] > 0.0 && !isNaN(c[0]) && !isNaN(c[1])) ) {
                pa[k++] = c[0];
                pa[k++] = c[1];
              }
            }
          }
          if ( k > 4 ) {
            if ( pa.length != k ) {
              var ta = new Float32Array(k);
              for ( var j = 0 ; j < k ; j++ )
                ta[j] = pa[j];
              pa = ta;
            }
            contours.push(pa);
          }
        }
        this.view.projection.strict = false;
        var vi = this.tessellate(contours);
        if ( vi && vi.count ) {
          var threshold = 16; // sub-divide threshld(pix)
          if ( texture ) {
            for ( var j = 0 ; j < vi.count ; j+=3 ) {
              this.setElement('texture', 'triangles', {texture:texture.id});
              var pts = [];
              for ( var k = 0 ; k < 3 ; k++ ) {
                var index = vi.triangles[j+k]*2;
                pts.push(
                  [vi.vertices[index], vi.vertices[index+1]]
                );
              }
              var divided = [];
              if ( !screen_base )
                this.subDivisionTriangles(divided, pts, threshold*threshold);
              else
                divided = pts;
              for ( var l = 0 ; l < divided.length ; l+=3) {
                var pts = [];
                for ( var k = 0 ; k < 3 ; k++ ) {
                  var x = divided[l+k][0];
                  var y = divided[l+k][1];
                  var c = this.view.point([x, y]);
                  if ( !isNaN(c[0]) && !isNaN(c[1]))
                    pts.push(c);
                }
                if ( pts.length != 3 )
                  continue;
                for ( var k = 0 ; k < 3 ; k++ ) {
                  var x = pts[k][0];
                  var y = pts[k][1];
                  var sp = this.view.screenPoint([x, y]);
                  this.setVertex13(x, y, 0, 0, 0, sp[0]/texture.width, sp[1]/texture.height,
                    1.0, 1.0, 1.0, 1.0, 0, this.alpha);
                }
              }
            }
          }
          else if ( fillStyle ) {
            var color = this.getColor(fillStyle);
            this.setElement('color', 'triangles', {});
            for ( var j = 0 ; j < vi.count ; j+=3 ) {
              var pts = [];
              for ( var k = 0 ; k < 3 ; k++ ) {
                var index = vi.triangles[j+k]*2;
                pts.push(
                  [vi.vertices[index], vi.vertices[index+1]]
                );
              }
              var divided = [];
              if ( !screen_base )
                this.subDivisionTriangles(divided, pts, threshold*threshold);
              else
                divided = pts;
              for ( var l = 0 ; l < divided.length ; l+=3) {
                var pts = [];
                for ( var k = 0 ; k < 3 ; k++ ) {
                  var x = divided[l+k][0];
                  var y = divided[l+k][1];
                  var c = this.view.point([x, y]);
                  if ( !isNaN(c[0]) && !isNaN(c[1]))
                    pts.push(c);
                }
                if ( pts.length != 3 )
                  continue;
                for ( var k = 0 ; k < 3 ; k++ ) {
                  var x = pts[k][0];
                  var y = pts[k][1];
                  this.setVertex11(x, y, 0, color[0], color[1], color[2], color[3], 0, 0, 0, this.alpha);
                }
              }
            }
          }
        }
      }
    }

    if ( strokeStyle ) {
      lines = stroke_lines;
      if ( !lineWidth )
        lineWidth = 1;

      // グラデーション判定
      var isGradient = typeof strokeStyle === 'object' && strokeStyle.type === 'gradation';

      if ( isGradient ) {
        // === グラデーション描画 ===
        var gradientColors = [];
        var gradientStops = [];

        // strokeStyle.opt
        // 例: [
        //             {ratio: 0, color: 'rgb(0, 0, 255)'},
        //             {ratio: 0.25, color: 'rgb(0, 255, 255)'},
        //             {ratio: 0.5, color: 'rgb(0, 255, 0)'},
        //             {ratio: 0.75, color: 'rgb(255, 255, 0)'},
        //             {ratio: 1, color: 'rgb(255, 0, 0)'}
        //     ]
        var colorStops = strokeStyle.opt || [
          [0, strokeStyle.colorStart || '#000000'],
          [1, strokeStyle.colorEnd || '#FFFFFF']
        ];

        for (var k = 0; k < colorStops.length; k++) {
          var stop = colorStops[k];
          gradientStops.push(stop.ratio);
          gradientColors.push(this.getColor(stop.color));
        }

        this.setDisplayBufferState(['zoom','center']);

        for ( var i = 0 ; i < lines.length ; i++ ) {
          var line = lines[i];

          // 線全体の長さを計算
          var totalLength = 0;
          var lengths = [0];
          for ( var j = 1 ; j < line.length ; j++ ) {
            var dx = line[j][0] - line[j-1][0];
            var dy = line[j][1] - line[j-1][1];
            var segLength = Math.sqrt(dx*dx + dy*dy);
            totalLength += segLength;
            lengths.push(totalLength);
          }

          // スクリーン座標に変換 + 進行度を計算
          var array = [];
          for ( var j = 0 ; j < line.length ; j++ ) {
            var p = line[j];
            var pt = this.view.screenPoint([p[0], p[1]]);
            var progress = totalLength > 0 ? lengths[j] / totalLength : 0;
            array.push([pt[0], pt[1], j, progress]);
          }

          var res = this.makeDashedArray(array, lineWidth*0.5, lineDash);

          var vtx = [];
          for ( var j = 0 ; j < res.length ; j++ ) {
            var v = res[j];
            var index = v[2];
            var a = line[index];
            var s = array[index];
            var progress = array[index][3];
            vtx.push([a[0], a[1], a[2], progress, v[0]-s[0], -v[1]+s[1]]);
          }

          this.setElement('gradient', 'triangleStrip', {
            gradientColors: gradientColors,
            gradientStops: gradientStops
          });

          for ( var j = 0 ; j < vtx.length ; j++ ) {
            var p = vtx[j];
            this.setVertex7(p[0], p[1], p[2]||0, p[3], p[4], p[5], this.alpha);
          }
        }
      } else {
        //=== 既存の単色処理（変更なし）===
        var color = this.getColor(strokeStyle);
        if ( lineWidth <= 1 && (!lineDash || !lineDash.length) ) {
          for ( var i = 0 ; i < lines.length ; i++ ) {
            var line = lines[i];
            this.setElement('color', 'lineStrip', {});
            for ( var j = 0 ; j < line.length ; j++ ) {
              var p = line[j];
              this.setVertex11(p[0], p[1], p[2]||0, color[0], color[1], color[2], color[3], 0, 0, 0, this.alpha);
            }
          }
        }
        else {
          this.setDisplayBufferState(['zoom','center']);
          for ( var i = 0 ; i < lines.length ; i++ ) {
            var line = lines[i];
            var array = [];
            for ( var j = 0 ; j < line.length ; j++ ) {
              var p = line[j];
              var pt = this.view.screenPoint([p[0],p[1]]);
              array.push([pt[0], pt[1], j]);
            }
            var res = this.makeDashedArray(array, lineWidth*0.5, lineDash);

            var vtx = [];
            for ( var j = 0 ; j < res.length ; j++ ) {
              var v = res[j];
              var index = v[2];
              var a = line[index];
              var s = array[index];
              vtx.push([a[0], a[1], a[2], v[0]-s[0], -v[1]+s[1]]);
            }

            this.setElement('color', 'triangleStrip', {});
            for ( var j = 0 ; j < vtx.length ; j++ ) {
              var p = vtx[j];
              this.setVertex11(p[0], p[1], p[2]||0, color[0], color[1], color[2], color[3], 0, p[3], p[4], this.alpha);
            }
          }
        }
      }

      if ( additional_lines.length ) {
        var vtx = additional_lines[i];
        this.setElement('color', 'lines', {});
        for ( var i = 0 ; i < additional_lines.length ; i++ ) {
          var p = additional_lines[i];
          this.setVertex11(p[0], p[1], p[2]||0, color[0], color[1], color[2], color[3], 0, 0, 0, this.alpha);
        }
      }
    }
  },

  // Pointのアンチエイリアスをキレイにするためオーバーライド
  drawPoint: function(point, size, lineWidth, strokeStyle, fillStyle, blink) {
    if ( blink )
      this.animating = true;

    if ( !point )
      return;
    var sp = this.view.screenPoint(point);
    if ( isNaN(sp[0]) || isNaN(sp[1]) )
      return;

    if ( !this.setDisplayBuffer() )
      return;

    blink = blink?1.0:0.0;
    this.setElement('point', 'points', {blink:blink});
    var x = point[0];
    var y = point[1];
    var z = point[2] || 0;
    while ( x >= 180.0 )
      x -= 360.0;
    while ( x < -180.0 )
      x += 360.0;
    var wo = 0;
    if ( this.view.projection.wrap_around ) {
      var wp = this.view.point([sp[0]+size,sp[1]]);
      wo = (Math.abs(wp[0]-point[0])%360);
    }

    // size -= 2.0;
    size -= 1.0; // アンチエイリアスをシェーダー側で処理するようにした結果、サイズが少し大きくなったので調整

    if ( fillStyle ) {
      if ( size > 0 ) {
        var color = this.getColor(fillStyle);
        this.setVertex10(x, y, z, color[0], color[1], color[2], color[3], size, 0, blink);
        if ( wo ) {
          if ( -180 <= x && x < -180+wo )
            this.setVertex10(x+360, y, z, color[0], color[1], color[2], color[3], size, 0, blink);
          if ( 180-wo < x && x < 180 )
            this.setVertex10(x-360, y, z, color[0], color[1], color[2], color[3], size, 0, blink);
        }
      }
    }
    if ( strokeStyle ) {
      if ( lineWidth === undefined )
        lineWidth = 1;
      var color = this.getColor(strokeStyle);
      var size_in = size-lineWidth;
      var size_out = size+lineWidth;
      if ( size_in < 0 )
        size_in = 0;
      if ( size_out > 0 ) {
        this.setVertex10(x, y, z, color[0], color[1], color[2], color[3], size_out, size_in, blink);
        if ( wo ) {
          if ( -180 <= x && x < -180+wo )
            this.setVertex10(x+360, y, z, color[0], color[1], color[2], color[3], size_out, size_in, blink);
          if ( 180-wo < x && x < 180 )
            this.setVertex10(x-360, y, z, color[0], color[1], color[2], color[3], size_out, size_in, blink);
        }
      }
    }
  },

  // mag_filterを外部から指摘できるようにするため、オーバーライド
  drawTile: function(tile, imageData, elevationData, transparent, min_filter, mag_filter) {
    this.layer._immediate = true;

    if ( !this.setDisplayBuffer() )
      return;

    var strokeStyle = null;
    //var strokeStyle = 'rgba(0,255,0,0.2)';  // enable for debug

    var l_block = WRAP.Memory.get();
    if ( elevationData ) {
      var line = [];
      var ce = elevationData;
      var cr = null, cc = null, cb = null;
      if ( ce && ce.around ) {
        cr = ce.around[3];
        cc = ce.around[4];
        cb = ce.around[5];
      }
      // line [2] -> data line[3] -> index
      var sep = 64;
      var stride = Math.floor(256/sep);
      var index_b, index_t;
      for ( var y = 0 ; y < sep ; y++ ) {
        line.push([0,y/sep,ce,(255-y*stride)*256]);
        for ( var x = 0 ; x < sep ; x++ ) {
          var index_x = x*stride;
          index_t = (255-y*stride)*256+index_x;
          line.push([x/sep, y/sep, ce, index_t]);

          index_b =  (y+1)*stride;
          if ( index_b >= 256 ) {
            index_b = 255*256+index_x;
            line.push([x/sep, (y+1)/sep, cb, index_b]);
          }
          else {
            index_b = (255-index_b)*256+index_x;
            line.push([x/sep, (y+1)/sep, ce, index_b]);
          }
        }
        // x == sep
        index_t = (255-y*stride)*256;
        line.push([x/sep, y/sep, cr, index_t]);
        index_b =  (y+1)*stride;
        if ( index_b >= 256 ) {
          index_b = 255*256;
          line.push([x/sep, (y+1)/sep, cc, index_b]);
          line.push([x/sep, (y+1)/sep, cc, index_b]);
        }
        else {
          index_b = (255-index_b)*256;
          line.push([x/sep, (y+1)/sep, cr, index_b]);
          line.push([x/sep, (y+1)/sep, cr, index_b]);
        }
      }

      WRAP.Memory.realloc(l_block, (sep+4)*(sep+2)*3);
      var d = [10000.0*1.0, 10000.0/255.0, 10000.0/65025.0, 10000.0/160581375.0];
      for ( var i = 0 ; i < line.length ; i++ ) {
        var p = line[i];
        l_block.data[l_block.length++] = p[0];
        l_block.data[l_block.length++] = p[1];
        var alt = p[2] && p[2].data;
        if ( alt ) {
          var index = p[3]*4;
          var r = alt[index];
          var g = alt[index+1];
          var b = alt[index+2];
          var a = r*d[0]+g*d[1]+b*d[2];
          l_block.data[l_block.length++] = a;
        }
        else {
          l_block.data[l_block.length++] = 0;
        }
      }
    }
    else {
      var sep = this.projection.tiling == 'M'?1:16;
      WRAP.Memory.realloc(l_block, sep*(sep*2+4)*3);
      for ( var y = 0 ; y < sep ; y++ ) {
        l_block.data[l_block.length++] = 0;
        l_block.data[l_block.length++] = y/sep;
        l_block.data[l_block.length++] = 0;
        for ( var x = 0 ; x < sep ; x++ ) {
          l_block.data[l_block.length++] = x/sep;
          l_block.data[l_block.length++] = y/sep;
          l_block.data[l_block.length++] = 0;
          l_block.data[l_block.length++] = x/sep;
          l_block.data[l_block.length++] = (y+1)/sep;
          l_block.data[l_block.length++] = 0;
        }
        // x == sep
        l_block.data[l_block.length++] = x/sep;
        l_block.data[l_block.length++] = y/sep;
        l_block.data[l_block.length++] = 0;
        l_block.data[l_block.length++] = x/sep;
        l_block.data[l_block.length++] = (y+1)/sep;
        l_block.data[l_block.length++] = 0;
        l_block.data[l_block.length++] = x/sep;
        l_block.data[l_block.length++] = (y+1)/sep;
        l_block.data[l_block.length++] = 0;
      }
    }

    var x = tile.bounds.west/60;
    var y = tile.bounds.south/60;
    var w = tile.bounds.east/60-x;
    var h = tile.bounds.north/60-y;
    var texture = this.getTileTexture(imageData, min_filter, mag_filter);

    var d = (x+w/2)-this.center[0];
    var offset = 0;
    if ( this.dynamic_tile_align ) {
      if ( d >= 180 )
        offset = -360;
      else if ( d < -180 )
        offset = 360;
    }

    var start = 0;
    var end = l_block.length/3;
    if ( tile.type == 'E' && tile.z == 0 ) { // orthoで南北90度以北のタイルを描くと問題が生じるための措置
      start = (end>>2);
      end = start + (end>>1);
    }
    this.setElement('tile', 'triangleStrip', {texture:texture.id, transparent:transparent}, this.feature);
    for ( var j = start ; j < end ; j++ ) {
      var p = j*3;
      var p0 = l_block.data[p];
      var p1 = l_block.data[p+1];
      var p2 = l_block.data[p+2];
      var z = p2|| 0;
      var lon = x+p0*w+offset;
      var lat = y+p1*h;
      this.setVertex6(lon, lat, z, p0, 1.0-p1, this.alpha);
    }
    // タイルの隙間対策（西端タイルを180度の右側にも描く）
    if ( this.view.projection.wrap_around && x == -180 ) {
      offset = 360;
      for ( var j = start ; j < end ; j++ ) {
        var p = j*3;
        var p0 = l_block.data[p];
        var p1 = l_block.data[p+1];
        var p2 = l_block.data[p+2];
        var z = p2|| 0;
        var lon = x+p0*w+offset;
        var lat = y+p1*h;
        this.setVertex6(lon, lat, z, p0, 1.0-p1, this.alpha);
      }
    }

    if ( strokeStyle ) {
      var color = this.getColor(strokeStyle);
      this.setElement('color', 'lineStrip', {});
      for ( var j = start ; j < end ; j++ ) {
        var p = j*3;
        var p0 = l_block.data[p];
        var p1 = l_block.data[p+1];
        var p2 = l_block.data[p+2];
        var z = p2|| 0;
        this.setVertex11(x+p0*w+offset, y+p1*h, z, color[0], color[1], color[2], color[3], 0, 0, 0, this.alpha);
      }
    }
    WRAP.Memory.release(l_block);
  },

  // mag_filterを外部から指摘できるようにするため、オーバーライド
  getTileTexture: function(img, min_filter, mag_filter) {
    var tileCache = this.gl._cache.tile;
    for ( var i = 0 ; i < tileCache.length ; i++ ) {
      var item = tileCache[i];
      if ( item.img == img ) {
        tileCache.splice(i,1);
        tileCache.unshift(item);
        return item.texture;
      }
    }
    var gl = this.gl;
    if ( tileCache.length == this.tileCacheMax ) {
      var t = tileCache.pop();
      if ( t )
        gl.deleteTexture(t.id);
      //console.log("tileChache ***");
    }
    var texture = new this.TileTexture(this.gl, img, min_filter, mag_filter);
    tileCache.unshift({img:img, texture:texture});
    //console.log("tileChache len="+this.tileCache.length+" file:"+img.src+ " gl:"+gl._cache.id);
    return texture;
  },

  // アイコンの描画がボヤけるのでTextureをオーバーライド
  Texture: function(gl, img, background) {

    var h = this.width = img.width;
    var v = this.height = img.height;
    var s = h>v?h:v;
    var size = 16;
    while ( size < s )
      size *= 2;
    var aw = h/size;
    var ah = v/size;
    // var canvas = document.createElement('canvas');
    // var ctx = canvas.getContext('2d');
    // backgroundがある場合は willReadFrequently: true のcontextを使用
    var {canvas, ctx} = getTextureCanvas(!!background);
    canvas.width = canvas.height = size;

    var tex;
    var usedCanvas = false;

    if ( img.data ) {
      ctx.putImageData(img, 0, 0);
      tex = canvas;
    }
    else {
      ctx.drawImage(img, 0, 0, h, v);
      if ( background ) {
        tex = ctx.getImageData(0,0,size,size);
        var p = tex.data;
        for ( var i = 0 ; i < p.byteLength ; i+=4) {
          if ( p[i+3] == 0) {
            p[i] = background[0];
            p[i+1] = background[1];
            p[i+2] = background[2];
          }
        }
      }
      else {
        tex = canvas;
        usedCanvas = true;
      }
    }

    this.id = gl.createTexture();
    if ( this.id ) {
      gl.bindTexture(gl.TEXTURE_2D, this.id);
      try {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, tex);
      } catch (e) {
        if (usedCanvas) {
          console.warn('CORS-tainted canvas detected, falling back to ImageData');
        } else {
          throw e; // 予期しないエラーは再スロー
        }
      }


      // アイコン・UI向けのシャープな設定
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); // LINEAR_MIPMAP_NEAREST →　LINEAR

      // エッジの処理  CLAMP_TO_EDGE をコメントアウト → デフォルトの REPEAT を使用
      // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      // gl.generateMipmap(gl.TEXTURE_2D); // 削除
      gl.bindTexture(gl.TEXTURE_2D, null);
    }

    this.vertices = function(width, height) {
      var vtx = [];
      vtx.push([ 0,     0,      0,  0]);
      vtx.push([ width, 0,      aw, 0]);
      vtx.push([ 0,     -height, 0,  ah]);
      vtx.push([ width, -height, aw, ah]);
      return vtx;
    }
  },
  // CanvasContextで追加した関数をWebGLにも追加
  textMetricsAccurate: function (text, font_size) {
    if ( !this.font_cvs ) {
      this.font_cvs = document.createElement('canvas');
      this.font_ctx = this.font_cvs.getContext('2d');
    }
    this.font_ctx.font = `${font_size}px Arial`;
    var a = this.font_ctx.measureText(text);
    return [a.width, a.actualBoundingBoxAscent + a.actualBoundingBoxDescent];
  },
});
/* eslint-enable */
